import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';
import * as ModelCreators from './../util/model_creators';
import { dateParams as dateParamsUtil } from './utilities';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.RefererPairs.meta.exhausted) return;
    if (getState().AnalyticsDashboard.RefererPairs.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_REFERER_PAIRS_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    $.when(
      Ajax.AllTimeHitsByRefererService(),
      Ajax.HitsService(dateParams),
      Ajax.WorksService(dateParams),
    )
      .done(
        function (AllTimeHitsByRefererResponse, hitsResponse, worksResponse) {
          const refererPairs = ModelCreators.RefererPairs(
            AllTimeHitsByRefererResponse[0].referer_hit_counts,
            hitsResponse[0].hits,
            worksResponse[0].works,
          );

          dispatch({
            type: TYPES.FETCH_REFERER_PAIRS_SUCCESS,
            refererPairs: refererPairs,
          });
        },
      )
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_REFERER_PAIRS_FAILURE,
        });
      });
  };
};

const RefererPairs = {
  fetch: fetch,
};
export { RefererPairs };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_REFERER_PAIRS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_REFERER_PAIRS_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.refererPairs),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_REFERER_PAIRS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
